import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import TitleBar from "../../../partials/content/TitleBar";

function AllNative() {
  const [allCampaignNative, setAllCampaignNative] = useState();
  const [allAdvertiseNative, setAllAdvertiseNative] = useState();
  const [campaignIDSelected, setCampaignIDSelected] = useState();

  useEffect(() => {
    // getAllAdvertiseNativeUser();
    // getAllCampaignNative();
  }, []);

  const getAllAdvertiseNativeUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allAdvertiseNativeUser = await sendRequestGetAllAdvertiseNativeUser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (allAdvertiseNativeUser.length == 0) {
      setAllAdvertiseNative(generateDoesNotHaveAnyAdvertiseTag());
      return;
    }
    setAllAdvertiseNative(
      await generateAllAdvertiseNativeUsers(allAdvertiseNativeUser)
    );
  };

  const generateConfirmTag = (confirm) => {
    let classNameConfirmAdvertise;
    let textConfirmAdvertise;
    switch (confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
    }

    return [classNameConfirmAdvertise, textConfirmAdvertise];
  };

  const generateAllAdvertiseNativeUsers = (allAdvertiseNativeUser) => {
    allAdvertiseNativeUser = allAdvertiseNativeUser.map(
      (advertiseNativeUser, index) => {
        let classNameStateAdvertise = advertiseNativeUser.active
          ? "success"
          : "danger";
        let textStateAdvertise = advertiseNativeUser.active
          ? "فعال"
          : "غیر فعال";
        const [classNameConfirmAdvertise, textConfirmAdvertise] =
          generateConfirmTag(advertiseNativeUser.confirm);

        return (
          <tr key={index}>
            <td>{helpersNumbers.toPersianNum(index + 1)}</td>
            <td>{helpersNumbers.toPersianNum(advertiseNativeUser.id)}</td>
            <td>
              {helpersNumbers.toPersianNum(advertiseNativeUser.campaign_id)}
            </td>

            <td>{advertiseNativeUser.campaign_name}</td>
            <td>
              {helpersNumbers.toPersianNum(advertiseNativeUser.created_at)}
            </td>
            <td>
              {helpersNumbers.toPersianNum(advertiseNativeUser.updated_at)}
            </td>
            <td className=" text-center">
              <a
                className="btn btn-primary text-center"
                target="_blank"
                href={advertiseNativeUser.link}
              >
                <i className="fa fa-globe"></i>
              </a>
            </td>
            <td>
              <div className="text-center">
                <span className={`badge badge-${classNameStateAdvertise} `}>
                  {textStateAdvertise}
                </span>
              </div>
            </td>
            <td>
              <div className="text-center">
                <span className={`badge badge-${classNameConfirmAdvertise}`}>
                  {textConfirmAdvertise}
                </span>
              </div>
            </td>
            <td>
              <div>
                <span className="pl-2">
                  <Link
                    to={`/advertise/native/edit/${advertiseNativeUser.id} `}
                    className="btn btn-outline-success  "
                  >
                    <i className="fa fa-edit"></i>
                  </Link>
                </span>
                <span>
                  <span
                    onClick={() => {
                      deleteAdvertiseNative(advertiseNativeUser.id);
                    }}
                    className="btn btn-outline-danger  btn-danger"
                  >
                    <i className="fa fa-trash"></i>
                  </span>
                </span>
              </div>
            </td>
          </tr>
        );
      }
    );

    const deleteAdvertiseNative = async (advertiseNativeUserID) => {
      const result = window.confirm("آیا مطمئن هستید؟");
      if (!result) {
        return;
      }

      if (await sendRequestDeleteNativeAdvertise(advertiseNativeUserID)) {
        await getAllAdvertiseNativeUser();
      }
    };

    const sendRequestDeleteNativeAdvertise = async (advertiseNativeUserID) => {
      helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      const headersRequest = getHeaderForRequest();
      try {
        await httpService.deleteRequest(
          process.env.REACT_APP_DOMAIN_API +
            "/v1/advertise/native/" +
            advertiseNativeUserID,
          headersRequest
        );
      } catch (error) {
        alert(error.response.data.message);
        return false;
      }
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return true;
    };

    return (
      <div className="table-responsive pt-3">
        <table className="table table-bordered table-dark tbl-td-white-space table-hover m-0">
          <thead>
            <tr>
              <td>#</td>
              <td>شماره تبلیغ</td>
              <td>شماره کمپین</td>
              <td>نام کمپین</td>
              <td>تاریخ ایجاد</td>
              <td>تاریخ بروزرسانی</td>
              <td>آدرس فرود</td>
              <td>وضعیت</td>
              <td>یررسی</td>
              <td>عملیات</td>
            </tr>
          </thead>
          <tbody>{allAdvertiseNativeUser}</tbody>
        </table>
      </div>
    );
  };

  const generateDoesNotHaveAnyAdvertiseTag = () => {
    return (
      <>
        <div>
          <div class="d-flex flex-column flex-md-row">
            <div class="text-center text-md-right">
              <img src="/assets/img/donot-have-campaign.svg" />
            </div>
            <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
              <p>شما هیچ تبلیغ همسان ندارید :(</p>
              <p>برای شروع کار یک تبلیغ بسازید.</p>
              <p>
                لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) به متنی آزمایشی
                و بی‌معنی در صنعت چاپ
              </p>
              <p>چگونه تبلیغ بسازم؟</p>
            </div>
          </div>
        </div>
      </>
    );
  };

  const sendRequestGetAllAdvertiseNativeUser = async () => {
    const headersRequest = getHeaderForRequest();
    let allAdvertiseNative;
    try {
      allAdvertiseNative = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/advertise/native",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAdvertiseNative.data.data;
  };

  const getAllCampaignNative = async () => {
    const allCampaignNative = await sendRequestGetAllCampaignNative();
    setAllCampaignNative(
      await generateGetAllCampaignNativeTag(allCampaignNative)
    );
  };

  const generateGetAllCampaignNativeTag = (allAdvertiseNative) => {
    return allAdvertiseNative.map((campaignNative, index) => {
      return (
        <option key={index} value={campaignNative.id}>
          {campaignNative.name}
        </option>
      );
    });
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllCampaignNative = async () => {
    const headersRequest = getHeaderForRequest();
    let allCampaignNative;
    try {
      allCampaignNative = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/campaign/native",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allCampaignNative.data.data;
  };

  const selectCampaignUser = (e) => {
    const link = "/advertise/native/add";
    const valueSelectBox = parseInt(e.target.value);
    if (valueSelectBox) {
      document
        .querySelector("#btn-add-advertise-native")
        .classList.remove("d-none");
      setCampaignIDSelected(valueSelectBox);
    } else {
      document
        .querySelector("#btn-add-advertise-native")
        .classList.add("d-none");
    }
  };

  const btnAddAdvertiseNativeClick = () => {
    document.querySelector("#select-campaign").classList.remove("d-none");
    document
      .querySelector("#select-campaign select")
      .classList.remove("d-none");
  };

  return (
    <>
      <Sidebar openItem="all-advertise" activeItem="add-advertise-native" />

      <div className="content-wrapper">
        <TitleBar title="تبلیغات همسان" />

        <section className="content pt-5">
          {/* <section className="content">
          <div className="card">
            <div className="card-body">
              {allAdvertiseNative}

              <div className="d-flex pt-3">
                <div
                  onClick={btnAddAdvertiseNativeClick}
                  className="btn btn-success ml-2"
                  to="/advertise/native/add"
                >
                  <span className="pl-2">
                    <i className="fa fa-plus"></i>
                  </span>
                  <span>
                    <span>اضافه کردن تبلیغ جدید به کمپین</span>
                  </span>
                </div>
                <div className="ml-2 d-inline d-none " id="select-campaign">
                  <select
                    className="form-control d-none "
                    onChange={(e) => {
                      selectCampaignUser(e);
                    }}
                  >
                    <option>کمپین خود را انتخاب کنید</option>
                    {allCampaignNative}
                  </select>
                </div>
                <div className="d-none " id="btn-add-advertise-native">
                  <Link
                    to={`/advertise/native/add/` + campaignIDSelected}
                    className="btn btn-success"
                  >
                    اضافه کردن
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section> */}
          <div className="card">
            <div className="card-body">
              <div>
                <div className="alert alert-info">
                  <span className="pl-3">
                    <i className="fa fa-info"></i>
                  </span>
                  <span>این بخش به زودی پیاده سازی خواهد شد</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllNative;
